define(["require", "exports", "jquery", "./ajaxCart", "./analytics"], function (require, exports, $, ajaxCart_1, analytics_1) {
    "use strict";
    exports.__esModule = true;
    function default_1(e, actionUrl, select) {
        if (select === void 0) { select = '.product-variant-block'; }
        e.preventDefault();
        analytics_1["default"]('cart', 'addProduct');
        var $variants = $(select);
        $variants = $variants.filter(function (i) {
            var $variant = $(this);
            return $variant.find('.qty-input').val() > 0;
        });
        var postData = {};
        $variants.each(function (i, v) {
            var $variant = $(v);
            var $inputs = $variant.find('.qty-input')
                .add($variant.find('.attributes input'))
                .add($variant.find('.attributes select'));
            var formKey = 'add_to_cart_variant_' + $variant.data('variant-id');
            var existing = postData[formKey];
            var formData = $inputs.serialize();
            if (!existing) {
                postData[formKey] = formData;
            }
            else if (Array.isArray(existing)) {
                existing.push(formData);
            }
            else {
                postData[formKey] = [existing, formData];
            }
        });
        if (!$variants.length) {
            return null;
        }
        return ajaxCart_1.AjaxCart.instance().addProductVariantsToCart(actionUrl, postData);
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/addToCart.js
// module id = 77
// module chunks = 0